import { Component, OnInit } from '@angular/core';

import { RestaurantService } from './restaurant.service';

import { RestaurantMenu } from './restaurant-menu';

import 'rxjs/add/operator/switchMap';

@Component({
	selector: 'restaurant-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.css']
 
})

export class MenuComponent implements OnInit {

	constructor(
		private m_restaurant_service: RestaurantService,
  	) {}
	m_menu: RestaurantMenu[];
	m_menu_id: string = "";
        menulist = 12;
      

	ngOnInit(): void {
		this.getRestaurantMenu();
                  this.menulist = 12;
                  			console.log("MENU ",)
	}
	getRestaurantMenu(): void {
		console.log("MenuComponent getRestaurantMenu")
		this.m_restaurant_service.getRestaurantMenu(this.m_restaurant_service.name).then(
			menu => {
				this.m_menu = menu
				this.m_menu_id = this.m_menu[0].categorie.ID
				console.log("THIS MENU ID ",this.m_menu)

                               
			}

                      
		);

	
	}

	clickedMenuItem(menuCategoryId) : void {
		this.m_menu_id = menuCategoryId;
                
	}
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/menu.component.ts